// Get babel-polyfill
import 'babel-polyfill';

// Get DefaultModule
import {DefaultModule} from 'stein';

export class Bootstrap extends DefaultModule {

    constructor() {

        super();

        // Subscribe DOMReady functions to the DOMReady event
        if (typeof this.DOMReady === 'function') {
            this.subscribe('DOMReady', this.DOMReady);
        }

        // on DOMContentLoaded, publish DOMReady
        document.addEventListener('DOMContentLoaded', () => this.publish('DOMReady'));

    }

}
